<template>
  <div class="main">
    <div class="wx-tip" id="wxTip">
      <img src="@/assets/img/wx-tip.png" alt="" />
    </div>

    <div class="main-head">
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" id="bg-svg">
        <path
          d="M181.785 183.552C48.1231 153.293 16.1 171.596 -2 183.552V0H390V183.552C390 183.552 315.446 213.81 181.785 183.552Z"
          fill="#F0935F"
        />
      </svg>
      <div
        style="
          width: 100%;
          height: 55px;
          left: -3px;
          top: 130px;
          position: absolute;
          text-align: center;
          color: rgba(255, 255, 255, 0.25);
          font-size: 42px;
          font-family: Microsoft YaHei UI;
          font-weight: 600;
          line-height: 15px;
          letter-spacing: 6px;
          word-wrap: break-word;
        "
      >
        PSYCHOLOGY
      </div>
      <img
        style="
          width: 79px;
          height: 79px;
          left: calc(50% - 39.5px);
          top: 81px;
          position: absolute;
          border-radius: 10px;
        "
        src="@/assets/img/logo.png"
        alt=""
      />
      <div
        style="
          width: 292px;
          height: 31px;
          left: -28px;
          top: 16px;
          position: absolute;
          text-align: center;
          color: rgba(255, 255, 255, 0.25);
          font-size: 32px;
          font-family: Microsoft YaHei UI;
          font-weight: 290;
          line-height: 15px;
          letter-spacing: 1px;
          word-wrap: break-word;
        "
      >
        ASSESSMENT
      </div>
      <div
        style="
          width: 292px;
          height: 31px;
          left: -77px;
          top: 79px;
          position: absolute;
          text-align: center;
          color: rgba(255, 255, 255, 0.25);
          font-size: 20px;
          font-family: Microsoft YaHei UI;
          font-weight: 290;
          line-height: 15px;
          letter-spacing: 1px;
          word-wrap: break-word;
        "
      >
        SELF-CARE
      </div>
      <div
        style="
          width: 292px;
          height: 31px;
          left: 100px;
          top: 61px;
          position: absolute;
          text-align: center;
          color: rgba(255, 255, 255, 0.25);
          font-size: 32px;
          font-family: Microsoft YaHei UI;
          font-weight: 290;
          line-height: 15px;
          letter-spacing: 1px;
          word-wrap: break-word;
        "
      >
        KNOWLEDGE
      </div>
      <div
        style="
          height: 31px;
          right: 10px;
          top: 13px;
          position: absolute;
          text-align: center;
          color: rgba(255, 255, 255, 0.25);
          font-size: 24px;
          font-family: Microsoft YaHei UI;
          font-weight: 290;
          line-height: 15px;
          letter-spacing: 1px;
          word-wrap: break-word;
        "
      >
        POTCAST
      </div>
    </div>

    <div class="main-body">
      <div
        style="
          width: 162px;
          height: 179.1px;
          left: 65px;
          top: 0px;
          position: absolute;
        "
      >
        <div class="animated-btn">
          <div id="box" class="animated infinite pulse slow">
            <button
              type="button"
              id="open"
              class="open-btn open-app"
              @click="handleBtnTap"
            >
              立即查看
            </button>
          </div>
        </div>
      </div>
      <div class="title">朝 夕</div>
      <div class="sub-title_1">身心健康 时刻相伴</div>
      <div class="sub-title_2" style="">AI对话·测评·练习·心理科普</div>
    </div>

    <div class="main-foot">
      <img style="width: 100%; height: 94px" src="@/assets/img/AI.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      env: "prod",
    };
  },
  mounted() {
    const _this = this;
    _this.resizeSVG();

    window.onresize = function() {
      return (() => {
        _this.resizeSVG();
      })();
    };
  },
  methods: {
    resizeSVG() {
        var svg = window.document.querySelector('svg');
        svg.setAttribute('width', window.innerWidth);
        svg.setAttribute('height', 197);
        svg.setAttribute('viewBox', "0 0 "+window.innerWidth+" 197");

        var path = window.document.querySelector("path");
        path.setAttribute('d', "M181.785 183.552C48.1231 153.293 16.1 171.596 -2 183.552V0H"+window.innerWidth+"V183.552C"+window.innerWidth+" 183.552 315.446 213.81 181.785 183.552Z");
        path.setAttribute('fill', "#F0935F");
        // svg.setAttribute('path', path);
    },    
    getUrlKey(name) {
      var val =
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null;
      return !!val ? val : "";
    },
    handleBtnTap(e) {
      const u = navigator.userAgent;
      const isMicro = u.toLowerCase().indexOf("micromessenger") !== -1; // 微信内
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

      var _id = this.getUrlKey("id");
      var _target_type = this.getUrlKey("target_type");
      var _invite_code = this.getUrlKey("invite_code");

      var query_param = "?id=" + _id + "&target_type=" + _target_type + "&invite_code=" + _invite_code;

      const schemeUrl = "zhaoxi://tech.roboai.daily/" + query_param;
      const androidDownloadUrl = "https://file.robopsy.cn/downloads/zhaoxi-release.apk";
      // const uatAndroidDownloadUrl = "https://file.robopsy.cn/downloads/uat/zhaoxi-release.apk";
      const universalLink = "https://app.robopsy.cn/" + query_param;
      const iosAppStoreUrl = "https://apps.apple.com/app/id1638518059";

      // 微信内
      if (isMicro) {
        // 显示手动打开外置浏览器提示
        document.getElementById("wxTip").style.display = "block";

        document.getElementById("wxTip").onclick = function () {
          this.style.display = "none";
        };
      } else {
        //android端
        if (isAndroid) {
          // 安卓app的scheme协议
          window.location.href = schemeUrl;

          // 三秒没跳转页面则下载app
          setTimeout(function () {
            let hidden =
              window.document.hidden ||
              window.document.mozHidden ||
              window.document.msHidden ||
              window.document.webkitHidden;
            if (typeof hidden == "undefined" || hidden == false) {
              //Apk下载地址
              window.location.href = androidDownloadUrl;
              //this.state.env == "prod" ? androidDownloadUrl : uatAndroidDownloadUrl;
            }
          }, 3000);
        }
        //ios端
        else if (isIOS) {
          //ios的scheme协议
          let startIndex = u.indexOf("iPhone OS") + 9;
          let endIndex = u.indexOf("like Mac OS") - 1;
          let num = +u.slice(startIndex, endIndex).split("_")[0]; // 计算版本号的前面数值
          if (num < 9) {
            // URL scheme 链接
            window.location.href = schemeUrl;
          } else {
            // URL scheme 链接
            window.location.href = schemeUrl;
          }

          setTimeout(function () {
            let hidden =
              window.document.hidden ||
              window.document.mozHidden ||
              window.document.msHidden ||
              window.document.webkitHidden;
            if (typeof hidden == "undefined" || hidden == false) {
              //App store下载地址
              window.location.href = iosAppStoreUrl;
            }
          }, 3000);
        }
      }
    },
  },
};
</script>

<style scoped>
.main {
  position: relative;
  width: 100%;
  height: 100%;
  background: white;
}

.animated-btn {
  position: absolute;
  width: 162px;
  height: 46.1px;
  left: 0px;
  top: 143px;
}

.main-head {
  width: 100%;
  height: 197px;
  background-color: #ffffff;
}

.main-foot {
  position: fixed;
  left: 15px;
  right: 16px;
  bottom: 18px;
}

.main-body {
  position: absolute;
  width: 292px;
  height: 179.1px;
  left: calc(50% - 146px);
  top: 263px;
}

.main-body .title {
  position: absolute;
  left: calc(50% - 48px);
  top: 0px;
  width: 96px;
  text-align: center;
  color: #f0935f;
  font-size: 28px;
  font-family: Microsoft YaHei UI;
  font-weight: 400;
  line-height: 38px;
  word-wrap: break-word;
}

.main-body .sub-title_1 {
  height: 32px;
  left: 66px;
  top: 45px;
  position: absolute;
  text-align: center;
  color: #f0935f;
  font-size: 18px;
  font-family: Microsoft YaHei UI;
  font-weight: 290;
  line-height: 32px;
  word-wrap: break-word;
}

.main-body .sub-title_2 {
  width: 292px;
  height: 31px;
  left: 0px;
  top: 75px;
  position: absolute;
  text-align: center;
  color: #f0935f;
  font-size: 11px;
  font-family: Microsoft YaHei UI;
  font-weight: 290;
  line-height: 31px;
  letter-spacing: 2px;
  word-wrap: break-word;
}

.main-foot img {
  width: 100%;
  height: 94px;
}

.head-bg {
  /* background: url("@/assets/img/head-bg.svg"); */
  background-repeat: no-repeat;
  background-size: contain;
  width: 100%;
}

#bg-svg {
  /* position: fixed; */
  width: 100%;
  height: 100%;
}

.open-btn {
  width: 162px;
  height: 46.1px;
  line-height: 46.1px;
  background: #f0935f;
  border-radius: 10px;
  border: 2px #f0935f solid;
  text-align: center;
  color: #ffffff;
}

.open-app {
  line-height: 46.1px;
  text-align: center;
  border: none;
  border-radius: 8px;
  color: #ffffff !important;
  background: #f0935f;
  font-size: 20px;
  text-decoration: none;
}

.wx-tip {
  background: rgba(0, 0, 0, 0.8);
  text-align: right;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 998;
  display: none;
}

.wx-tip img {
  width: 100%;
  height: auto;
}

.pulse {
  -webkit-animation-name: pulse;
  animation-name: pulse;
}
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
.animated.slow {
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
}

@-webkit-keyframes pulse {
  from {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }
  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
@keyframes pulse {
  from {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }
  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
</style>